<template>
  <div class="addCommondity">
    <div class="goodsManageDetailPage">
      <div class="banner">
        <img src="../../assets/images/banner1.png" alt="" />
      </div>
      <div class="breadcrumb flex-rowc">
        <div class="breadcrumb_icon">
          <i class="iconfont icon-shangpinsku"></i>
        </div>
        <div class="breadcrumb_item">SKU管理</div>
        <div class="breadcrumb_item_arrow"></div>
        <div class="breadcrumb_item">商品管理</div>
      </div>

      <div class="main_content">
        <div class="block">
          <h1><span class="mark">*</span>商品名称</h1>
          <div class="block_wrap">
            <p>中文名称</p>
            <div class="input_box">
              <van-field
                v-model="formData.commodityname"
                placeholder="输入商品中文名称"
              />
            </div>
          </div>

          <div class="block_wrap">
            <p>英文名称</p>
            <div class="input_box">
              <van-field
                v-model="formData.commodityname_e"
                placeholder="Enter product name"
              />
            </div>
          </div>
          <div class="block_wrap">
            <p>越南语名称</p>
            <div class="input_box">
              <van-field
                v-model="formData.commodityname_y"
                placeholder="Nhập tên sản phẩm"
              />
            </div>
          </div>
          <div class="block_wrap">
            <p>俄语名称</p>
            <div class="input_box">
              <van-field
                v-model="formData.commodityname_m"
                placeholder="Название товара"
              />
            </div>
          </div>
          <div class="block_wrap">
            <p>泰语名称</p>
            <div class="input_box">
              <van-field
                v-model="formData.commodityname_t"
                placeholder="ป้อนชื่อสินค้า"
              />
            </div>
          </div>
          <div class="block_wrap">
            <p>日语名称</p>
            <div class="input_box">
              <van-field
                v-model="formData.commodityname_r"
                placeholder="日本語の名称です"
              />
            </div>
          </div>
        </div>

        <div class="block">
          <h1><span class="mark">*</span>商品SKU采购编码，ISBN编码设置</h1>
          <p style="width: 80%; margin: auto">
            请注意，如果您的产品没有这两组编码，请随意输入一组6~30位数英文和数字组合的编码即可。<br /><br />

            SKU采购编码，和ISBN编码，是为了更方便的管理线上线下产品数据而设置，每件商品的两类编码都具备独一性，不可与其他产品重复，一旦设置，不可更改，请慎重输入。<br /><br />
            我们强烈建议您独立建立自己产品的SKU采购编码，对数据进行严谨管理。
          </p>
        </div>

        <div class="block">
          <div class="input_box">
            <van-field v-model="formData.sku" placeholder="输入SKU采购编码" />
          </div>
          <div class="input_box">
            <van-field v-model="formData.ISBN" placeholder="输入ISBN编码" />
          </div>
          <p>ISBN编码为非必填项</p>
        </div>

        <div class="block">
          <h1><span class="mark">*</span>商品品牌设置</h1>
          <p>
            请注意，商品的品牌信息一经设置不可更改，<br />
            为了您的数据管理严谨性，请谨慎输入！
          </p>
        </div>

        <div class="block">
          <div class="input_box" @click="isShow = true">
            <van-field
              v-model="brandName"
              placeholder="选择设置品牌"
              readonly
            />
          </div>
        </div>

        <div class="block">
          <h1>商品添加注意事项</h1>
          <p>
            请注意，商品一经添加后，如需删除，请联系管理员。<br /><br />

            添加的商品为你的企业所专属的商品。<br />
            添加完成后，系统将自动赋予商品ID，并与你的企业ID关联，<br />
            随后请进一步完善商品详细信息。
          </p>
        </div>
        <div class="block">
          <h1><span class="mark">*</span>是否提供Ai试穿服务</h1>
          <div class="radio_box">
            <van-radio-group v-model="formData.isableware">
              <van-radio name="是">是</van-radio>
              <van-radio name="否">否</van-radio>
            </van-radio-group>
          </div>
        </div>
      </div>

      <div class="primary-button" @click="query">确认</div>
      <div class="primary-button return" @click="handleReturn">
        <i class="iconfont icon-yuyinjiantou"></i> 返回
      </div>
      <!-- <div class="return-fixd">
        
      </div> -->
    </div>

    <van-popup v-model="isShow">
      <div class="brandPopup">
        <div class="content">
          <div class="head">
            <div class="close" @click="isShow = false"></div>
            <div class="tit">
              <h1>商品品牌设置：</h1>
              <p>
                请注意，品牌一经设置不可更改，<br />
                为了您的数据管理严谨性，请谨慎输入！
              </p>
            </div>
            <div class="input_box search" v-if="false">
              <van-field
                v-model="searchText"
                placeholder="输入品牌关键字查找→"
              />
            </div>
          </div>
          <div class="body">
            <van-radio-group v-model="formData.brandid" direction="horizontal">
              <van-radio
                v-for="item in brandList"
                :key="item.id"
                checked-color="#ee0a24"
                :name="item.id"
                >{{ item.labelname }}</van-radio
              >
            </van-radio-group>
          </div>
          <div class="footer flex-rowc">
            <div class="btn" @click="handleQueryBanrd">确认</div>
            <p @click="hanldGoBrand">前往添加品牌→</p>
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { getBrandList, addCommidity } from "../../api/api";
export default {
  name: "addCommondity",
  data() {
    return {
      isShow: false,

      radio: "",
      searchText: "",
      isShowStyle: false,
      scrollTop: 0,

      brandName: "",
      brandList: "",
      formData: {
        commodityname: "",
        commodityname_e: "",
        commodityname_m: "",
        commodityname_y: "",
        commodityname_t: "",
        commodityname_r: "",
        sku: "",
        ISBN: "",
        brandid: "",
        shortname: "",
        shortname_e: "",
        shortname_m: "",
        shortname_y: "",
        shortname_t: "",
        comtype: "",
        labelid: "",
        labelid2: "",
        labelid3: "",
        paytype: "",
        groupnum: "",
        qyid: "",
        openid: "",
        createman: "",

        istop: 0, // 是否置顶
        isintro: "否", // 是否精品推荐
        ispre: false, // 是否预售
        islimit: "不限购", // 是否限购
        commoditystate: "下架", // 是否上架
        salestate: "正常销售", // 销售状态
        isjoindevide: 1,   // 是否参与分销合作服务 =1=参与分销合作服务 0=不参与分销合作服务
        isableware: ''  // 是否试穿 是、否
      },
      qyguid: "",
    };
  },
  created() {
    let userInfo = this.$store.state.USERINFO;
    if (userInfo.qy) {
      this.formData.qyid = userInfo.qy.id;
      this.qyguid = userInfo.qy.qyguid;
    } else {
      this.formData.qyid = 0;
      this.qyguid = 0;
    }
    this.formData.openid = userInfo.openid;
    this.formData.createman = userInfo.truename
      ? userInfo.truename
      : userInfo.nickname;
    this.getBrand();
  },
  methods: {
    // 品牌标签
    getBrand() {
      let { qyguid } = this;
      getBrandList({ qyguid }).then((res) => {
        this.brandList = res;
      });
    },
    handleQueryBanrd() {
      let { formData, brandList } = this;
      if (formData.brandid == "") {
        this.$toast("请选择品牌");
        return;
      } else {
        let filter = brandList.filter((v) => v.id == formData.brandid);
        this.brandName = filter[0].labelname;
        this.isShow = false;
      }
    },
    hanldGoBrand() {
      this.$router.push("/brandIndex/brandDetail");
    },
    // 返回上一页
    handleReturn() {
      history.back();
    },

    // 提交数据
    query() {
      let { formData } = this;

      if (formData.commodityname == "") {
        this.$toast("请输入商品名称");
        return;
      }
      if (formData.commodityname.length <= 2) {
        this.$toast("请输入商品名称最少2个字符");
        return;
      }
      if (formData.sku == "") {
        this.$toast("请输入SKU采购编码");
        return;
      }
      // if (formData.ISBN == "") {
      //   this.$toast("请输入ISBN编码");
      //   return;
      // }
      if (formData.brandid == "") {
        this.$toast("请选择商品品牌");
        return;
      }
      if (formData.isableware == "") {
        this.$toast("请选择是否提供Ai试穿服务");
        return;
      }
      const Toast = this.$toast.loading({
        message: "提交中...",
        forbidClick: true,
      });
      addCommidity(formData).then((res) => {
        if (res.result) {
          this.$toast.success(res.message);
          setTimeout(() => {
            this.$router.back();
          }, 2000);
        } else {
          Toast.clear();
          this.$toast.fail(res.message);
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.goodsManageDetailPage {
  padding-bottom: 380px;
  .main_content {
    font-size: 30px;
    color: #444444;
    h1 {
      text-align: center;
      font-weight: 400;
      margin-bottom: 35px;
    }
    input {
      text-align: center;
    }
    .block {
      margin-bottom: 100px;
      .block_wrap {
        width: 600px;
        margin: auto;
        p {
          // text-align: left;
          font-size: 24px;
          color: #444444;
          margin-bottom: 10px;
        }
      }
      .radio_box {
        .van-radio {
          margin-bottom: 10px;
        }
      }
    }
    .input_box {
      margin-bottom: 30px;
    }
    p {
      line-height: 30px;
      font-size: 22px;
      color: #ff0012;
      text-align: center;
    }
  }
}
.brandPopup {
  position: relative;
  .content {
    width: 680px;
    height: 55vh;
    // padding: 50px;
    box-sizing: border-box;
    .head {
      height: 11vh;
      padding: 30px 40px 0;
      box-sizing: border-box;
      .tit {
        margin-bottom: 25px;
        h1 {
          font-size: 30px;
          color: #6e6e6e;
          font-weight: 400;
          margin-bottom: 15px;
        }
        p {
          font-size: 20px;
          color: #ff0012;
          line-height: 30px;
        }
      }
      .input_box {
        width: 100%;
        margin: 40px auto 50px;
      }
    }

    .body {
      height: 34vh;
      overflow-y: scroll;
      padding: 0 20px 0 40px;
    }

    .van-radio {
      margin-bottom: 25px;
      width: 50%;
      /deep/ .van-radio__label {
        font-size: 14px !important;
        color: #6e6e6e;
      }
    }
    .footer {
      height: 10vh;
      flex-flow: column;
      font-size: 22px;
      color: #fe3c46;
      .btn {
        width: 130px;
        height: 50px;
        border-radius: 25px;
        text-align: center;
        line-height: 50px;
        font-size: 22px;
        color: #fff;
        background: #f62560;
        margin-bottom: 30px;
      }
    }
    .close {
      position: absolute;
      top: 15px;
      right: 13px;
    }
  }
}
</style>